<div class="overflow-x-hidden">
  <ng-content></ng-content>
</div>
